import type { App } from 'vue'
export default {
  install: (app: App, options: any): void => {
    app.provide('i18n', options)
    //   app.directive('my-directive', {
    //     mounted (el, binding, vnode, oldVnode) {
    //       // some logic ...
    //     }
    //   })
    //   app.mixin({
    //     created() {
    //       // some logic ...
    //     }
    //   })
  }
}
